// @flow
import React, { Fragment } from 'react'
import isEmpty from 'ramda/es/isEmpty'

import Loading from 'app/common/components/Loader'

import HelpIntro from './help-intro'
import HelpContacts from './help-contacts'
import useHelpInfoData from './useHelpInfoData'
import HelpSuppliers from './help-suppliers'

/**
 *  Вступительнвя часть раздела помощи
 *  Выводятся информация о FAQ, инструкции, расписание, контакты
 */

const HelpInfo = () => {
  const { supportData, loading } = useHelpInfoData()
  const {
    questionsUrl,
    instructionsUrl,
    contacts,
    schedule,
    suppliers,
  } = supportData

  const emptyIntro = !questionsUrl && !instructionsUrl
  const emptyContacts = isEmpty(contacts) && isEmpty(schedule)

  if (loading) {
    return (<Loading />)
  }

  return (
    <Fragment>
      {!emptyIntro
        && <HelpIntro
          questionsUrl={questionsUrl}
          instructionsUrl={instructionsUrl}
        />}

      {
        !emptyContacts
        && <HelpContacts
          contacts={contacts}
          schedule={schedule}
        />
      }
      {
        !emptyContacts
        && suppliers?.map(supplierItem => (<HelpSuppliers
          supplier={supplierItem}
        />))
      }
    </Fragment>
  )
}

export default HelpInfo
